import { render, staticRenderFns } from "./welcome.vue?vue&type=template&id=6dc496a4&scoped=true&lang=pug&"
import script from "./welcome.vue?vue&type=script&lang=js&"
export * from "./welcome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc496a4",
  null
  
)

export default component.exports